export default __webpack_public_path__ + "static/media/14.94f2cc46.png";